import React from 'react';
import NavBar from '../components/navbar';
import { Paper, Typography, Button } from '@material-ui/core';
import '../styles/account.css';
import * as auth from '../data/firebaseAuth';
import FirebaseConnector from '../data/FirebaseConnector';
import history from '../components/history';

const rootClass = "account root";
const titleClass = "account title";
const buttonClass = "account button";
const contentClass = "account content";

class Account extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            user: null,
        }
    }

    async componentDidMount() {
        const db = new FirebaseConnector();
        const u = await db.getUserData();
        this.setState({user: u})
        if(!u) {
            history.push('/');
        }
    }

    render() {
        return (
            <>
                <NavBar />
                <Paper className={rootClass}>
                    <Typography variant="h3" className={titleClass}>Account</Typography>
                    <hr />
                    {this.state.user !== null && (
                        <div className={contentClass}>
                        <div>
                            <Typography variant="overline">Name: </Typography>
                            <Typography variant="caption">{this.state.user.name}</Typography>
                        </div>
                        <div>
                            <Typography variant="overline">Email: </Typography>
                            <Typography variant="caption">{this.state.user.email}</Typography>
                        </div>
                        </div>
                    )}
                    <hr />
                    <Button color="primary" className={buttonClass} variant="contained" fullWidth onClick={() => auth.logout()}>Logout</Button>
                </Paper>
            </>
        );
    }

}

export default Account;